import ReportList from '_modules/report/views/ReportList.vue';
import ReportDriveList from '_modules/report/views/ReportDriveList.vue';
import ReportSellerList from '_modules/report/views/ReportSellerList.vue';
import ReportQuotationList from '_modules/report/views/ReportQuotationList.vue';
import isAdminMiddleware from '@/router/middlewares/isAdminMiddleware';
// eslint-disable-next-line
const Report = r => require(['_modules/report/Root.vue'], r);

export default {
  path: 'relatorios/',
  component: Report,
  name: 'admin-report',
  redirect: 'relatorios/produtos/1',
  children: [
    {
      beforeEnter: isAdminMiddleware,
      path: 'produtos/:page',
      name: 'admin-report-list',
      component: ReportList,
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'vendedor/:page',
      name: 'admin-report-seller-list',
      component: ReportSellerList,
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'orcamentos/:page',
      name: 'admin-report-quotation-list',
      component: ReportQuotationList,
    },
    {
      beforeEnter: isAdminMiddleware,
      path: 'drives',
      name: 'admin-report-drive-list',
      component: ReportDriveList,
    },
  ],
};
